import { useVouchersData, searchOptions } from "./vouchersData";
import {
  SearchBar,
  Pagination as DynamicPagination,
  DateRangePicker,
  // Icon
} from "@components/index";
import VoucherListRender from "./components/VoucherListRender";
import VoucherDetailsModal from "./components/VoucherDetailsModal";

import "./index.scss";

const Vouchers = () => {
  // Use the custom hook for all vouchers logic
  const {
    vouchers: paginatedVouchers,
    allVouchers: filteredVouchers,
    loading,
    error,
    searchValue,
    handleSearch,
    fromDate,
    toDate,
    handleDateChange,
    currentPage,
    handlePageChange,
    handleClearFilters,
    handleViewVoucher,
    selectedVoucher,
    isModalOpen,
    handleCloseModal,
    // handleDownloadVoucherData, // download voucher data
  } = useVouchersData();

  return (
    <div className="vouchers-page">
      <div
        className="vouchers-page__header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <h1 className="vouchers-page__title">Voucher Management</h1>
          <p className="vouchers-page__subtitle">
            View and manage ATP vouchers
          </p>
        </div>

        {/* <button
          className="vouchers-page__download-btn"
          onClick={handleDownloadVoucherData}
        >
          <Icon
            iconName="downlaodIcon"
            height={16}
            width={16}
            className="download-icon"
          />
          Download MIS Data
        </button> */}
      </div>

      <div className="vouchers-page_filters">
        <div className="vouchers-page_filters-section">
          <SearchBar
            searchOptions={searchOptions}
            onSearch={handleSearch}
            showSearchButton={false}
            initialValue={searchValue}
          />

          <DateRangePicker
            fromDate={fromDate}
            toDate={toDate}
            onChange={handleDateChange}
            showClearButton
            className="vouchers-page_date-range-picker"
          />
        </div>

        <button
          className="vouchers-page_clear-btn"
          onClick={handleClearFilters}
        >
          Reset Filters
        </button>
      </div>

      {/* Vouchers List */}
      <VoucherListRender
        vouchers={paginatedVouchers}
        loading={loading}
        error={error}
        onClearFilters={handleClearFilters}
        onViewVoucher={handleViewVoucher}
      />

      {/* Pagination */}
      <DynamicPagination
        data={filteredVouchers}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        itemsPerPage={10}
        showInfo={true}
        showFirstButton={true}
        showLastButton={true}
      />

      {/* Voucher Details Modal */}
      <VoucherDetailsModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        voucher={selectedVoucher}
      />
    </div>
  );
};

export default Vouchers;
